//@flow
import * as Immutable from 'immutable';

import {
    WaybillUnusedSummaryResponse,
    UnusedSummaryItem
} from 'platform/settings/modules/orchestration/models/flow/WaybillUnusedSummaryResponse';
import type {
    WaybillUnusedSummaryResponseModelType,
    UnusedSummaryItemModelType
} from 'platform/settings/modules/orchestration/models/flow/WaybillUnusedSummaryResponse';

class InternalWaybillUnusedSummaryResponse extends WaybillUnusedSummaryResponse {
    static fromJS(
        json: WaybillUnusedSummaryResponseModelType
    ): InternalWaybillUnusedSummaryResponse {
        const state: Object = Object.assign({}, json);
        state.rows = Immutable.List(state.rows).map(item =>
            InternalUnusedSummaryItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalUnusedSummaryItem extends UnusedSummaryItem {
    static fromJS(json: UnusedSummaryItemModelType): InternalUnusedSummaryItem {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalWaybillUnusedSummaryResponse as WaybillUnusedSummaryResponse,
    InternalUnusedSummaryItem as UnusedSummaryItem
};
